import { ChangeDetectionStrategy, Component, computed, inject, input, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { ImageLoadingComponent } from '../image-loading/image-loading.component';
import { Home_DynamicBlocks_DynamicBlock } from '@proto/store/api/store/home';
import { WindowDetectService } from '@service/window-detect.service';
import { Links } from '@helper/links';
import { IframeDialogComponent } from '@common/iframe-dialog/iframe-dialog.component';
import { FocusRemoverDirective } from '@helper/focus-remover.directive';
import { LinkToUrl } from '@common/link-pipes';

@Component({
  selector: 'app-dynamic-block',
  templateUrl: './dynamic-block.component.html',
  styleUrls: ['./dynamic-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageLoadingComponent, FocusRemoverDirective, LinkToUrl],
})
export class DynamicBlockComponent {
  readonly windowService = inject(WindowDetectService);
  readonly warnText = '舊帳號服務';
  // if width does not set, it will fill the whole available spaces
  readonly width = input(0);
  readonly aspectRatio = input(1);
  readonly gapSize = input(20);
  readonly blocks = input<Home_DynamicBlocks_DynamicBlock[]>([]);
  readonly imgWidth = computed(
    () =>
      this.width() ||
      Math.floor(
        (this.windowService.windowWidth() - (this.blocks().length - 1) * this.gapSize()) / this.blocks().length
      )
  );
  readonly imgHeight = computed(() => this.aspectRatio() * this.imgWidth());

  private readonly router = inject(Router);
  private readonly dialog = inject(MatDialog);

  @Input() iconSize = 15;
  @Input() showTitle = false;

  onLinkClick(link: string, showInDialog: boolean): void {
    if (showInDialog) {
      IframeDialogComponent.open(this.dialog, link);
    } else {
      Links.handleLink(this.router, link, !this.windowService.isMobileDevice());
    }
  }
}
